import commonApi from './CommonApi.js';
import qs from "querystring";

export default {
	downloadMaterial: async (parameters) => {
		return await commonApi().get('/v1/resources/downloadMaterial',
			{
				params: parameters,
				paramsSerializer: (params) => {
					return qs.stringify(params);
				},
				responseType: 'blob'
			})
			.then((response) => {
				let fileName = parameters.type + '.pdf';
				let fileURL = window.URL.createObjectURL(new Blob([response.data]));
				let fileLink = document.createElement('a');

				fileLink.href = fileURL;
				fileLink.setAttribute('download', fileName);
				document.body.appendChild(fileLink);
				fileLink.click();
			})
			.catch((error) => {
				console.log(error.response);
			});
	},
}